import {
  Directive,
  HostListener,
  ElementRef,
  Renderer2,
  OnInit,
} from "@angular/core";

@Directive({
  selector: "[windowScrollDashboardBodyAction]",
})
export class WindowScrollDashboardBodyActionDirective implements OnInit {
  elemPosition;
  innerWidth;
  xs;
  heleprElem;

  constructor(public el: ElementRef, public renderer: Renderer2) {
    this.innerWidth = window.innerWidth;
    if (innerWidth <= 992) {
      this.xs = true;
    } else {
      this.xs = false;
    }
  }
  ngOnInit() {
    // add position fixed helper
    this.heleprElem = document.createElement("div");
    this.heleprElem.classList.add("small-dashboard-body-action-helper");
    this.el.nativeElement.before(this.heleprElem);
    // 15 = margin bottom for .dashboard-body-top
    this.renderer.setStyle(
      this.heleprElem,
      "height",
      this.el.nativeElement.clientHeight + 15 + "px"
    );
    this.renderer.setStyle(
      document.querySelector(".small-dashboard-body-action-helper"),
      "display",
      "none"
    );

    this.elemPosition = this.el.nativeElement.offsetTop;
  }

  @HostListener("window:scroll", ["$event"])
  @HostListener("window:resize", ["$event"])
  onScroll() {
    this.innerWidth = window.innerWidth;
    this.renderer.setStyle(
      this.heleprElem,
      "height",
      this.el.nativeElement.clientHeight + 15 + "px"
    );

    if (innerWidth <= 992) {
      this.xs = true;
    } else {
      this.xs = false;
    }

    if (!this.xs) {
      const scrolled =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (
              document.documentElement ||
              document.body.parentElement ||
              document.body
            ).scrollTop;

      const detailsNav = document.querySelectorAll("[windowscrollappnav]")[0];
      const dashboardbodytop = document.querySelectorAll(
        "[windowscrolldashboardbodytop]"
      )[0];

      if (detailsNav && dashboardbodytop) {
        if (scrolled >= this.elemPosition - 51 - 41 - 41) {
          this.renderer.addClass(
            this.el.nativeElement,
            "small-dashboard-body-action"
          );
          this.renderer.addClass(
            this.el.nativeElement,
            "small-dashboard-body-top-2ElemUp"
          );
          this.renderer.setStyle(
            document.querySelector(".small-dashboard-body-action-helper"),
            "display",
            "inline-block"
          );
        } else {
          this.renderer.removeClass(
            this.el.nativeElement,
            "small-dashboard-body-action"
          );
          this.renderer.removeClass(
            this.el.nativeElement,
            "small-dashboard-body-top-2ElemUp"
          );
          this.renderer.setStyle(
            document.querySelector(".small-dashboard-body-action-helper"),
            "display",
            "none"
          );
        }
      } else if (detailsNav || dashboardbodytop) {
        if (scrolled >= this.elemPosition - 51 - 41) {
          this.renderer.addClass(
            this.el.nativeElement,
            "small-dashboard-body-action"
          );
          this.renderer.setStyle(
            document.querySelector(".small-dashboard-body-action-helper"),
            "display",
            "inline-block"
          );
        } else {
          this.renderer.removeClass(
            this.el.nativeElement,
            "small-dashboard-body-action"
          );
          this.renderer.setStyle(
            document.querySelector(".small-dashboard-body-action-helper"),
            "display",
            "none"
          );
        }
      } else {
        if (scrolled >= this.elemPosition - 51) {
          this.renderer.addClass(
            this.el.nativeElement,
            "small-dashboard-body-action"
          );
          this.renderer.addClass(
            this.el.nativeElement,
            "small-dashboard-body-top-0ElemUp"
          );
          this.renderer.setStyle(
            document.querySelector(".small-dashboard-body-action-helper"),
            "display",
            "inline-block"
          );
        } else {
          this.renderer.removeClass(
            this.el.nativeElement,
            "small-dashboard-body-action"
          );
          this.renderer.removeClass(
            this.el.nativeElement,
            "small-dashboard-body-top-0ElemUp"
          );
          this.renderer.setStyle(
            document.querySelector(".small-dashboard-body-action-helper"),
            "display",
            "none"
          );
        }
      }
    }
  }
}
